import { useMutation } from "@tanstack/react-query";
import type { Feature } from "@unbox/api";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

type UpdateMerchantPayload = {
  merchantId: string;
  name?: string;
  features: Feature[];
  ownerWorkspaceId?: string | null;
};

export const useUpdateMerchant = () => {
  return useMutation({
    mutationFn: async (payload: UpdateMerchantPayload) => {
      const res = await client.admin.merchant[":id"].$put({
        param: { id: payload.merchantId },
        json: { name: payload.name, features: payload.features, ownerWorkspaceId: payload.ownerWorkspaceId },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "merchants"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "merchant", variables.merchantId] });
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
};
